import { useStyles } from "./GamingLoading.style";
import LogoIcon from "../../../assets/image/vodacom_logo_1x.webp";
import LogoIcon2x from "../../../assets/image/vodacom_logo_2x.webp";
import LogoIcon3x from "../../../assets/image/vodacom_logo_3x.webp";
import { StaticImage } from "../StaticImage";

const GamingLoading: React.FC = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <StaticImage
        src={LogoIcon}
        src2x={LogoIcon2x}
        src3x={LogoIcon3x}
        alt="gaming-loading"
        width={37}
        height={38}
      />
    </div>
  );
};

export default GamingLoading;
